"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Source = exports.SourceContext = void 0;

var React = _interopRequireWildcard(require("react"));

var _Map = require("./Map");

var SourceContext = /*#__PURE__*/React.createContext('');
exports.SourceContext = SourceContext;

function removeLayersOnSource(map, source) {
  if (map) {
    var _map$getStyle$layers;

    (_map$getStyle$layers = map.getStyle().layers) === null || _map$getStyle$layers === void 0 ? void 0 : _map$getStyle$layers.forEach(function (layer) {
      if (layer.source === source) {
        map === null || map === void 0 ? void 0 : map.removeLayer(layer.id);
      }
    });
  }
}

var Source = function Source(_ref) {
  var sourceId = _ref.sourceId,
      url = _ref.url,
      children = _ref.children;
  var map = React.useContext(_Map.MapContext);
  React.useEffect(function () {
    if (map === null || map === void 0 ? void 0 : map.loaded()) {
      map === null || map === void 0 ? void 0 : map.addSource(sourceId, {
        type: 'vector',
        url: "mapbox://".concat(url)
      });
    } else {
      map === null || map === void 0 ? void 0 : map.on('load', function (e) {
        map === null || map === void 0 ? void 0 : map.addSource(sourceId, {
          type: 'vector',
          url: "mapbox://".concat(url)
        });
      });
    }

    return function () {
      if ((map === null || map === void 0 ? void 0 : map.isStyleLoaded()) && (map === null || map === void 0 ? void 0 : map.getSource(sourceId))) {
        removeLayersOnSource(map, sourceId);
        map === null || map === void 0 ? void 0 : map.removeSource(sourceId);
        map === null || map === void 0 ? void 0 : map.off('load', function (e) {
          map === null || map === void 0 ? void 0 : map.addSource(sourceId, {
            type: 'vector',
            url: "mapbox://".concat(url)
          });
        });
      }
    };
  }, [map, sourceId, url]);
  return /*#__PURE__*/React.createElement(SourceContext.Provider, {
    value: sourceId
  }, children);
};

exports.Source = Source;